import React from 'react';
import { Box } from '@mui/material';

/** Typography wrapper for static legal HTML migrated from legacy. */
export default function LegalProse({ children }) {
  return (
    <Box
      sx={{
        '& h4': {
          fontSize: '1rem',
          fontWeight: 700,
          mt: 2,
          mb: 1,
          color: 'text.primary',
        },
        '& p': {
          fontSize: '0.9rem',
          lineHeight: 1.65,
          mb: 1.5,
          color: 'text.primary',
        },
        '& ul': {
          pl: 2.5,
          mb: 1.5,
        },
        '& li': {
          fontSize: '0.9rem',
          lineHeight: 1.55,
          mb: 0.5,
        },
        '& a': {
          color: 'primary.main',
          textDecoration: 'underline',
        },
      }}
    >
      {children}
    </Box>
  );
}
